import React from 'react';
import twMerge from 'twMerge';

import Icon from 'molecules/Icon';

import { headingContent, headingSubhead } from 'components/Form/Form.styles';

import richTextParser from 'utils/richTextParser/richTextParser';

import type { ContentfulComponentFormSubhead, Maybe } from 'graphqlTypes';
import type { RichText } from 'utils/richTextParser/richTextParser';

type FormHeadingProps = {
  isTwoStepForm: boolean | undefined;
  curStep: number;
  handlePrev: () => void;
  heading: Maybe<string> | undefined;
  subhead: Maybe<ContentfulComponentFormSubhead> | undefined;
};

const FormHeading: React.FC<FormHeadingProps> = ({ isTwoStepForm, curStep, handlePrev, heading, subhead }) => {
  if (isTwoStepForm) {
    if (curStep === 0) {
      return (
        <h2 className={twMerge(headingContent())} key="step-0-heading">
          Book a demo
        </h2>
      );
    } else {
      return (
        <div key="step-1-heading" className="flex items-center gap-4">
          <Icon icon="arrow-back" size={20} className="cursor-pointer" onClick={handlePrev} />
          <h2 className={twMerge(headingContent())}>Thanks! Tell us more</h2>
        </div>
      );
    }
  }

  return (
    <>
      {heading && (
        <h2 key="default-heading" className={twMerge(headingContent())}>
          {heading}
        </h2>
      )}
      {subhead && (
        <p key="default-subhead" className={twMerge(headingSubhead())}>
          {richTextParser(subhead as RichText)}
        </p>
      )}
    </>
  );
};

export default FormHeading;
